'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _isImmutable = require('./util/isImmutable');

var _isImmutable2 = _interopRequireDefault(_isImmutable);

var _isIndexed = require('./util/isIndexed');

var _isIndexed2 = _interopRequireDefault(_isIndexed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'shallowToJS',
    all: function all() {
        return function (value) {
            if (!(0, _isImmutable2.default)(value)) {
                return value;
            }
            if ((0, _isIndexed2.default)(value)) {
                return value.toArray();
            }
            return value.toObject();
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/shallowToJS.js
// module id = 906
// module chunks = 35783957827783